import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const crohns: AnswerPathTreeNode = {
  path: 'crohns',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredCrohnsDiseaseDetails }],
};
